// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Loader2, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FilterToggleProps {
  active: boolean;
  onChange: (active: boolean) => void;
  icon: LucideIcon;
  label: string;
  disabled?: boolean;
  /** Toggling this filter costs a round trip that is still in flight. */
  loading?: boolean;
}

export function FilterToggle({ active, onChange, icon: Icon, label, disabled, loading }: FilterToggleProps) {
  return (
    <Button
      variant="outline"
      disabled={disabled || loading}
      className={
        active
          ? "bg-sidebar-accent-hover hover:bg-sidebar-accent border-sidebar-accent hover:border-sidebar-primary text-sidebar-accent-foreground hover:text-sidebar-accent-foreground dark:bg-sidebar-accent dark:border-sidebar-accent dark:hover:bg-sidebar-accent-hover dark:hover:border-sidebar-primary"
          : "font-normal border-dashed"
      }
      onClick={() => onChange(!active)}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Icon className={`h-4 w-4 ${active ? "fill-sidebar-primary/25" : ""}`} />
      )}
      {label}
    </Button>
  );
}
